import React from "react";
import Swiper, { SwiperSlide } from "../../components/swiper";
import HeroSliderEightSingle from "../../components/hero-slider/HeroSliderEightSingle.js";
import sliderData from "../../data/hero-sliders/hero-slider-eight.json";

const HeroSliderEight = () => {
  const params = {
    effect: "fade",
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    watchSlidesVisibility: true,
  };
  return (
    <div className="slider-area">
      <div className="slider-active nav-style-1">
        <Swiper options={params}>
          {sliderData &&
            sliderData.map((single, key) => {
              return (
                <SwiperSlide key={key} >
                <HeroSliderEightSingle
                  data={single}
                  key={key}
                  sliderClass="swiper-slide"
                />
                 </SwiperSlide>
              );
            })}
        </Swiper>
      </div>
    </div>
  );
};

export default HeroSliderEight;
